import { TimePicker } from '@alifd/next';
import { getStructureFieldName } from '../utils';
import { useComponentContext } from '../../context/useComponentContext';
const React = window.React;
const { createElement, useEffect, useRef, useState } = React;
const moment = window.moment;
function timeDateToString(date) {
    if (!date)
        return '';
    if (moment) {
        return moment(date).format('HH:mm:ss');
    }
    const d = new Date(date);
    const h = String(d.getHours()).padStart(2, '0');
    const m = String(d.getMinutes()).padStart(2, '0');
    const s = String(d.getSeconds()).padStart(2, '0');
    return `${h}:${m}:${s}`;
}
const ProTimePicker = (props) => {
    const { screen_structure, screen_structure_field, defaultValue, disableEdit, ...otherProps } = props;
    const { structureName, structureField } = getStructureFieldName(screen_structure, screen_structure_field);
    const fieldPath = `${structureName}.${structureField}`;
    const { value, onValueChange } = useComponentContext(fieldPath);
    console.log('ProTimePicker useComponentContext value', value, fieldPath);
    const handleChange = (newValue) => {
        if (onValueChange) {
            onValueChange(timeDateToString(newValue));
        }
        if (props.onChange) {
            props.onChange(timeDateToString(newValue), structureName, structureField);
        }
    };
    return (createElement("span", { className: `field-wrapper ${disableEdit ? 'disable-edit' : 'enable-edit'}` },
        createElement(TimePicker, { ...props, value: value, onChange: handleChange })));
};
export default ProTimePicker;
